var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgActivveHome = function SvgActivveHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13.815,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "14.027%",
    y1: "-51.573%",
    x2: "88.304%",
    y2: "144.774%",
    id: "ActivveHome_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FBC",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BA88",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.905 12.966v-2.118c0-.54.469-.977 1.05-.98H8.08c.583 0 1.056.438 1.056.98v2.125c0 .457.394.83.886.842h1.418c1.413 0 2.559-1.064 2.559-2.375V5.414c-.008-.516-.269-1-.709-1.316L8.443.473a2.467 2.467 0 0 0-2.907 0L.71 4.105A1.64 1.64 0 0 0 0 5.42v6.02c0 1.311 1.146 2.375 2.559 2.375h1.418c.505 0 .914-.38.914-.85",
    fill: "url(#ActivveHome_svg__a)",
    stroke: "#006E50",
    fillRule: "evenodd"
  })));
};
export default SvgActivveHome;